import { useUserStore } from '~/store'

export const usePostFixMarket = () => {
  const userStore = useUserStore()
  const postfixMarket = computed(() => {
    if (userStore.isGlobalMarket) {
      return '-global'
    } else {
      return ''
    }
  })
  return {
    postfixMarket: postfixMarket.value,
  }
}
